export default {
  localStorageEmailLabel: 'user_email_saitama_company',
  localStorageIdLabel: 'user_id_saitama_company'
}
